// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { RECENT_TAGS_ORDER_BY_KEY, } from "../../../app/localStorageKeys"
import { RecentTagsOrderBy } from "../slice"

export type StorageWriter = (value: RecentTagsOrderBy) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(RECENT_TAGS_ORDER_BY_KEY, value.toString())
}

export const persistRecentOrderBy = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setRecentOrderBy.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.recentOrderByPersisted()),
        catchError(_ => of(Actions.recentOrderByPersistFailed())),
      )),
    )

export default persistRecentOrderBy(persist)

